export default function LocationsHeroSection() {
  return (
    <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/6f6fc7fad6b4d4112a537beb7239af91.jpg)'
        }}
      ></div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 sm:px-4">
        <div className="flex items-center justify-center text-center">
          <div className="text-white max-w-4xl">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 leading-tight">
              IDS教習所グループ 拠点一覧
            </h1>
            <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-8 sm:mb-10 leading-relaxed">
              佐賀・鹿児島の3拠点で、あなたの農業をサポートします
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
